// Simple seeded random number generator (Linear Congruential Generator)
function mulberry32(seed) {
  return function () {
    let t = seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}

// Function to generate a random number within a range using the seeded generator
function getSeededRandomNumber(min, max, seed) {
  const random = mulberry32(seed);
  return Math.floor(random() * (max - min + 1)) + min;
}

// Function to hash a string (product ID) into a number to use as a seed
function hashString(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash);
}

// Function to close a popup with fade-out animation
function closePopup(popupId) {
  const popup = document.getElementById(popupId);
  if (popup) {
    popup.classList.remove('fade-in');
    popup.classList.add('fade-out');
    setTimeout(() => {
      popup.style.display = 'none';
    }, 1000);
  }
}

// Initialize popups on page load
document.addEventListener('DOMContentLoaded', function () {
  // Desktop Popups (Sticky Preview)
  const purchasesPopupDesktop = document.getElementById('purchases-popup-desktop');
  const reviewersPopupDesktop = document.getElementById('reviewers-popup-desktop');
  const purchasesNumberDesktop = document.querySelector('#purchases-popup-desktop .bold-number-people');
  const reviewersNumberDesktop = document.querySelector('#reviewers-popup-desktop .bold-number');

  // Slider Popups
  const purchasesPopupSlider = document.getElementById('purchases-popup-slider');
  const reviewersPopupSlider = document.getElementById('reviewers-popup-slider');
  const purchasesNumberSlider = document.querySelector('#purchases-popup-slider .bold-number-people');
  const reviewersNumberSlider = document.querySelector('#reviewers-popup-slider .bold-number');

  // Get the product ID from the popup container
  const popupContainer = document.querySelector('.popup-container');
  const productId = popupContainer ? popupContainer.getAttribute('data-product-id') : 'default';

  // Generate a seed from the product ID
  const seed = hashString(productId);

  // Generate consistent random numbers using the seed
  const peopleViewing = getSeededRandomNumber(5, 31, seed); // Updated range to 5–31
  const reviewers = getSeededRandomNumber(89, 99, seed + 1);

  // Update popup numbers for Desktop
  if (purchasesNumberDesktop) {
    purchasesNumberDesktop.innerText = `${peopleViewing} people`; // Include "people" in the bold section
  }
  if (reviewersNumberDesktop) {
    reviewersNumberDesktop.innerText = `${reviewers}%`;
  }

  // Update popup numbers for Slider
  if (purchasesNumberSlider) {
    purchasesNumberSlider.innerText = `${peopleViewing} people`; // Include "people" in the bold section
  }
  if (reviewersNumberSlider) {
    reviewersNumberSlider.innerText = `${reviewers}%`;
  }

  // Automatically close popups after 6 seconds
  setTimeout(() => {
    if (purchasesPopupDesktop) closePopup('purchases-popup-desktop');
    if (reviewersPopupDesktop) closePopup('reviewers-popup-desktop');
    if (purchasesPopupSlider) closePopup('purchases-popup-slider');
    if (reviewersPopupSlider) closePopup('reviewers-popup-slider');
  }, 6000);
});